import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Viewer } from 'cesium';
import { CoreService } from '../../../../core/services/core.service';
import { CoresService } from '../../../../core/services/cores.service';
import * as Cesium from 'cesium';

interface GeneralSettings {
  showGrid: boolean;
  showLighting: boolean;
  showCrosshair: boolean;
  showCenterCoordinate: boolean;
  clusterFirstResponders: boolean;
  [key: string]: boolean;
}

@Component({
  selector: 'app-general-settings',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './general-settings.component.html',
  styleUrl: './general-settings.component.css'
})
export class GeneralSettingsComponent {

  settings: GeneralSettings = {
    showGrid: false,
    showLighting: false,
    showCrosshair: false,
    showCenterCoordinate: false,
    clusterFirstResponders: false
  };

  originalSettings: GeneralSettings;
  isDirty = false;
  viewer: any;
  imageryLayers: any;
  gridProvider: any;
  gridLayer: any;

  constructor(public CoresService: CoresService) {
    
    this.originalSettings = { ...this.settings };
  }
  // viewer = CoresService.getViewer();
  // imageryLayers = this.viewer?.imageryLayers;
  ngOnInit(): void {
  
    this.loadSettings();   
    this.viewer = this.CoresService.getViewer();
    this.imageryLayers = this.viewer.imageryLayers;
    this.gridProvider = new Cesium.GridImageryProvider({
      cells: 10,
      color: Cesium.Color.GRAY.withAlpha(0.5),
      glowColor: Cesium.Color.LIGHTGRAY.withAlpha(0.5),
      glowWidth: 1.0,
      backgroundColor: Cesium.Color.TRANSPARENT
    });
    this.gridLayer = null;
  }

  loadSettings(): void {
    const savedSettings = localStorage.getItem('generalSettings');
    if (savedSettings) {
      this.settings = JSON.parse(savedSettings);
      this.originalSettings = { ...this.settings };
    }
    
  }
isPageRefresh(): boolean {
  if (performance && performance.getEntriesByType) {
    const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    if (navEntries.length > 0) {
      return navEntries[0].type === 'reload'; // true if browser refresh
    }
  }
  return false;
}
  onSettingChange(key: string): void {
 
  // Check if settings have changed
  this.isDirty = JSON.stringify(this.settings) !== JSON.stringify(this.originalSettings);

  // Handle specific settings
  if (key === 'showGrid') {
    if (this.settings.showGrid) {
      this.showGrid();
    } else {
      this.hideGrid();
      // Optionally, also turn off lighting when grid is off
     
    }
  }

  if (key === 'showLighting') {
    if (this.settings.showLighting) {
      this.showLighting();
    } else {
      this.hideLighting();
    }
  }


    if (this.settings.showCrosshair) {
      this.showCrosshair();
    } else {
      this.hideCrosshair();
    }

    if (this.settings.showCenterCoordinate) {
      this.showCenterCoordinate();
    } else {
      this.hideCenterCoordinate();
    }

    if (this.settings.clusterFirstResponders) {
      this.clusterFirstResponders();
    } else {
      this.unclusterFirstResponders();
    }

  this.saveSettings(); // Immediately persist changes
}

  saveSettings(): void {
    localStorage.setItem('generalSettings', JSON.stringify(this.settings));
    this.originalSettings = { ...this.settings };
    this.isDirty = false;
  }

  resetSettings(): void {
    // Reset to true defaults
    this.settings = {
      showGrid: false,
      showLighting: false,
      showCrosshair: false,
      showCenterCoordinate: false,
      clusterFirstResponders: false
    };
    this.isDirty = false;
    this.gridLayer = null;
    this.saveSettings();
  }

  // Grid methods
  private showGrid(): void {
    if (this.imageryLayers && this.gridProvider && !this.isGridVisible()) {
      this.gridLayer = this.imageryLayers.addImageryProvider(this.gridProvider);
    }
  }

  private hideGrid(): void {
    if (this.viewer && this.viewer.imageryLayers) {
      const layers = this.viewer.imageryLayers;
      for (let i = layers.length - 1; i >= 0; i--) {
        const layer = layers.get(i);
        if (layer.imageryProvider instanceof Cesium.GridImageryProvider) {
          layers.remove(layer, false);
        }
      }
      this.gridLayer = null;
    }
  }

  private isGridVisible(): boolean {
    return !!this.imageryLayers && !!this.gridLayer && this.imageryLayers.contains(this.gridLayer);
  }

  // Lighting methods
  private showLighting(): void {
    if (this.viewer && this.viewer.scene && this.viewer.scene.globe) {
      this.viewer.scene.globe.enableLighting = true;
    }
  }

  private hideLighting(): void {
    if (this.viewer && this.viewer.scene && this.viewer.scene.globe) {
      this.viewer.scene.globe.enableLighting = false;
    }
   
  }

  // Crosshair methods
  private showCrosshair(): void {
    // Implement crosshair show logic
  }

  private hideCrosshair(): void {
    // Implement crosshair hide logic
  }

  // Center Coordinate methods
  private showCenterCoordinate(): void {
    // Implement center coordinate show logic
  }

  private hideCenterCoordinate(): void {
    // Implement center coordinate hide logic
  }

  // First Responders methods
  private clusterFirstResponders(): void {
    // Implement cluster first responders logic
  }

  private unclusterFirstResponders(): void {
    // Implement uncluster first responders logic
  }
} 